"use client";

import { MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ProfileCard = ({ profile, variant = "mobile" }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate("/chatdetail?name=" + profile.chat_name)}
      className={`relative rounded-2xl overflow-hidden aspect-[3/4] bg-gray-100 ${
        variant === "desktop"
          ? "hover:scale-105 transition-transform"
          : "active:scale-95 transition-transform"
      }`}
    >
      <img
        src={profile.profile_picture || "/placeholder.svg"}
        alt={`${profile.chat_name} profile`}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      <div
        className={`absolute bottom-0 left-0 right-0 text-white ${
          variant === "desktop" ? "p-4" : "p-3"
        }`}
      >
        <h3
          className={`font-semibold ${
            variant === "desktop" ? "text-xl mb-2" : "text-lg mb-1"
          }`}
        >
          {profile.chat_name} ,{profile.age}
        </h3>
        <div className="flex items-center gap-1 text-sm mb-3">
          <MapPin size={variant === "desktop" ? 16 : 12} />
          <span>{profile.distance}</span>
        </div>
        <div
          className={`inline-flex w-fit items-center gap-2 text-sm text-gray-800 font-medium
    bg-white/30 backdrop-blur-md  
    rounded-lg
    ${
      variant === "desktop"
        ? "pl-2 pr-2 py-2 text-lg"
        : "pl-1.5 pr-1.5 py-1.5 text-base"
    }`}
          style={{
            boxShadow: "0 4px 24px 0 rgba(31, 38, 135, 0.15)",
            // Optional: add a subtle border for extra glassmorphic feel
          }}
        >
          <span>☕</span>
          <span>{profile.activity}</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
